// extracted by mini-css-extract-plugin
module.exports = {"h2":"BaseTextH2_h2_D_PMs","wrapper":"BaseTextH2_wrapper_3elKZ"};